/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-no-bind */
import Icon, { CloseCircleOutlined } from "@ant-design/icons";
import { useLazyQuery, useQuery } from "@apollo/client";
import { Button, Checkbox, Input, Popover, Skeleton, Switch, Tabs, Tooltip, message } from "antd";
import { isEmpty } from "lodash";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EngagedAI from "../../../../static/EngagedAi_trans_bg.svg";
import TranslateIcon from "../../../../static/icons/TranslateIcon.svg";
import { UserContext } from "../../../amplify/authenticator-provider";
import { GET_AI_RESPONSE, GET_AI_SUGGESTION_QUICK_TIP } from "../../../graphql/query";
import AiSettingsIcon from "../../../icons/AiSettingsIcon";
import { SVGIcon } from "../../../library/basicComponents";
import { colorConfig } from "../../../library/colorConfig";
import { AccessPermissionAction } from "../../../library/constants";
import { checkAccessPermission } from "../../../library/helpers";
import { applicationUseCaseMapping, getApplicationUseCaseId } from "../../../library/utils";
import ChatMagic from "./chatMagic";
import "./editor.css";
import { InputTextAreaWrap } from "./engagementActivity";
import { setTextMode } from "../../../redux/slices/leadSlice";
import { EmailTextBox } from "./EmailTextBox";

const CustomizePrompt = ({ selectedLead, user, text, popupRef, setinputText, setloaderFn }) => {
  const [customizePromptData, setcustomizePromptData] = useState({
    visible: false,
    quickTips: [],
    tones: ["Polite"],
    additionalNote: "",
  });
  const Divider = () => <div className="w-full h-[2px] bg-grey-200 " />;
  const SectionHeader = ({ children }) => (
    <span className="text-sm font-[400] text-grey-700">{children}</span>
  );
  const Toggle = ({ children, onChange, value }) => (
    <div className="flex gap-1 flex-row items-center">
      <Switch onChange={onChange} checked={value} size="small" /> {children}
    </div>
  );
  const TabToggle = ({ children, isActive, onChange }) => {
    return (
      <div
        onClick={onChange}
        className={`px-4 py-2 cursor-pointer rounded border-[1px] border-solid  ${
          isActive ? "border-brand-500 bg-brand-50" : "border-grey-300"
        }`}
      >
        {children}
      </div>
    );
  };
  const keywordMapping = {
    firstTip: "generate an appointment",
    secondTip: "give a reminder text",
    thirdTip: "make it short",
    firstTone: "Polite",
    secondTone: "Funny",
    thirdTone: "Formal",
  };
  const [dynamicTips, setdynamicTips] = useState([]);
  const { applicationUseCases } = useSelector(state => state.aiData);
  const [getAiResponse, { loading: getAiResponseLoader }] = useLazyQuery(GET_AI_RESPONSE, {
    nextFetchPolicy: "network-only",
  });
  useEffect(() => {
    setloaderFn(getAiResponseLoader);
  }, [getAiResponseLoader]);
  const { loading: quickTipLoader } = useQuery(GET_AI_SUGGESTION_QUICK_TIP, {
    variables: {
      companyId: user.company.id,
      locationIds: sessionStorage.getItem("currentLocationId").split(","),
      applicationUseCaseId: getApplicationUseCaseId(
        applicationUseCases,
        applicationUseCaseMapping.ENGAGEMENT_MESSAGE_SUGGESTION
      )?.id,
    },
    onCompleted: res => {
      setdynamicTips(res.getAiSuggestionQuickTip);
    },
  });
  const close = () => popupRef?.current?.click();
  const getAiResponseHandler = async () => {
    text.current.placeholder = "Generating response...";
    text.current.value = "";
    text.current.style.height = "0px";
    text.current.focus();
    const promptData = { ...customizePromptData };
    delete promptData.visible;
    const payload = {
      aiSuggestionUserInput: { ...promptData },
      leadId: selectedLead.id,
      companyId: user.company.id,
      applicationUseCaseId: getApplicationUseCaseId(
        applicationUseCases,
        applicationUseCaseMapping.ENGAGEMENT_MESSAGE_SUGGESTION
      )?.id,
    };
    setloaderFn(true);
    const res = await getAiResponse({
      variables: payload,
    });
    const writeText = res?.data?.getAiResponse?.content;
    setloaderFn(false);
    let index = 0;
    if (!isEmpty(writeText)) {
      typeCharacter();
    }
    function typeCharacter() {
      if (index < writeText.length) {
        if (!isEmpty(text?.current)) {
          text.current.style.height = `${text.current.scrollHeight}px`;
          if (isEmpty(text?.current?.value)) {
            console.log(writeText.charAt(index), index);
            text.current.value = writeText.charAt(index);
            console.log(text.current.value);
          } else {
            text.current.value += writeText.charAt(index);
          }
          console.log(text.current.value);
          index++;
          if (index === writeText.length) {
            setinputText(writeText);
            setloaderFn(false);
          }
          setTimeout(typeCharacter, 20); // Adjust the delay (in milliseconds) between characters here
        }
      }
    }
    // text.current.value
    close();
  };
  return (
    <div className="flex flex-col" onClick={e => e.stopPropagation()}>
      <div className="flex flex-row p-3 bg-[#F1F5F9] justify-between">
        <span className="text-sm font-[600] text-grey-700 ">Customize AI Suggestion</span>
        <CloseCircleOutlined onClick={close} className="cursor-pointer" />
      </div>
      <div className="flex flex-col py-2 px-4 items-start ">
        <SectionHeader>Quick Tips</SectionHeader>
        <div className="flex flex-col items-start gap-1">
          {quickTipLoader ? (
            <Skeleton active paragraph={{ rows: 1 }} />
          ) : (
            dynamicTips.map((item, index) => (
              <Toggle
                key={index}
                onChange={checked => {
                  if (checked) {
                    setcustomizePromptData(prev => {
                      const temp = { ...prev };
                      temp.quickTips.push(item.tip);
                      return temp;
                    });
                  } else {
                    setcustomizePromptData(prev => {
                      const temp = structuredClone(prev);
                      const index = temp.quickTips.indexOf(item.tip);
                      temp.quickTips.splice(index, 1);
                      return temp;
                    });
                  }
                }}
                value={customizePromptData.quickTips.includes(item.tip)}
              >
                {item.tip}
              </Toggle>
            ))
          )}
        </div>
      </div>
      <Divider />
      <div className="flex flex-col py-2 px-4 items-start">
        <SectionHeader>Tone</SectionHeader>
        <div className="flex flex-row flex-wrap gap-4">
          {["Polite", "Funny", "Formal"].map((item, index) => (
            <TabToggle
              key={index}
              onChange={() => {
                setcustomizePromptData(prev => {
                  const temp = structuredClone(prev);
                  temp.tones = [item];
                  return temp;
                });
              }}
              isActive={customizePromptData?.tones?.includes(item)}
            >
              {item}
            </TabToggle>
          ))}
        </div>
      </div>
      <Divider />
      <div className="flex flex-col py-2 gap-1 px-4 items-start">
        <SectionHeader>Additional Notes</SectionHeader>
        <Input
          value={customizePromptData.additionalNote}
          onChange={e =>
            setcustomizePromptData({ ...customizePromptData, additionalNote: e.target.value })
          }
          placeholder="Type some notes..."
        />
        <Checkbox
          checked={customizePromptData.save}
          onChange={e => setcustomizePromptData({ ...customizePromptData, save: e.target.checked })}
        >
          Save these options
        </Checkbox>
        {customizePromptData.save && (
          <Input
            value={customizePromptData.filterName}
            onChange={e =>
              setcustomizePromptData({ ...customizePromptData, filterName: e.target.value })
            }
            placeholder="Enter preset customize name"
          />
        )}
        <Button
          loading={getAiResponseLoader}
          onClick={getAiResponseHandler}
          type="primary"
          className="w-full rounded-sm"
        >
          Regenerate
        </Button>
      </div>
    </div>
  );
};

function SuggestAMessageButton({
  createSuggestedResponse,
  misc,
  selectedLead,
  disabled,
  text,
  setinputText,
  setloaderFn,
}) {
  const popupRef = useRef(null);
  const { user } = useContext(UserContext);

  return (
    <Button
      key={selectedLead?.id}
      loading={misc.loading}
      className="text-lg flex bg-grey-200 hover:border-separate flex-row items-center justify-between p-1 gap-1"
      disabled={disabled}
      style={{
        borderWidth: "1px",
        borderColor: "black",
      }}
      // type="text"
    >
      <Tooltip title="Suggest message">
        <Icon
          component={EngagedAI}
          alt="SocialMiningAi"
          onClick={() => createSuggestedResponse()}
        />
      </Tooltip>
      <div className="h-[20px] w-[1px] bg-black" />
      <Tooltip title="Customize AI Suggestion">
        <Popover
          className=""
          overlayClassName="ai-prompt-popup"
          trigger="click"
          destroyTooltipOnHide
          content={
            <CustomizePrompt
              user={user}
              text={text}
              selectedLead={selectedLead}
              popupRef={popupRef}
              setinputText={setinputText}
              setloaderFn={setloaderFn}
            />
          }
        >
          <span
            onClick={e => e.stopPropagation()}
            className="flex-row-centered items-center"
            ref={popupRef}
          >
            <AiSettingsIcon className="scale-75 mt-1" />
          </span>
        </Popover>
      </Tooltip>
    </Button>
  );
}

export function InputArea(props) {
  const { textMode } = useSelector(state => state.lead);
  const dispatch = useDispatch();
  const [inputText, setinputText] = useState("");
  const [loaderFn, setloaderFn] = useState(false);
  const canDisabledConversation = checkAccessPermission(
    AccessPermissionAction.LEAD_MANAGEMENT_DISABLED_CONVERSATION
  );

  const canSendEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_SEND);

  useEffect(() => {
    if (!props?.messageText) {
      props?.setOriginalText?.("");
    }
  }, [props?.messageText]);

  useEffect(() => {
    // Set default active tab based on phone/email availability
    if (props?.selectedLead) {
      const hasPhone = !isEmpty(props.selectedLead.phoneNumbers);
      const hasEmail = !isEmpty(props.selectedLead.emails);

      if (!hasPhone && hasEmail) {
        dispatch(setTextMode("Email"));
      } else {
        dispatch(setTextMode("Text"));
      }
    }
  }, [props?.selectedLead?.id, dispatch]);

  useEffect(() => {
    if (props?.text?.current && isEmpty(props.text.current.value)) {
      setinputText("");
    }
  }, [props?.text]);

  const componentProps = {
    ...props,
    inputText,
    setInputMode: mode => dispatch(setTextMode(mode)),
    setinputText,
    loaderFn,
    setloaderFn,
    canDisabledConversation,
    disableToEmail: !canSendEmail,
  };

  const hasPhone = !isEmpty(props.selectedLead?.phoneNumbers);
  const hasEmail = !isEmpty(props.selectedLead?.emails);

  const tabItems = [
    {
      label: "Text",
      key: "Text",
      disabled: isEmpty(props.selectedLead) || !hasPhone,
      children: <SMSTextBox {...componentProps} />,
    },
    {
      label: "Email",
      key: "Email",
      disabled: isEmpty(props.selectedLead) || !hasEmail || !canSendEmail,
      children: <EmailTextBox {...componentProps} />,
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
      <Tabs
        activeKey={textMode}
        onChange={key => dispatch(setTextMode(key))}
        className="w-full"
        items={tabItems}
      />
    </div>
  );
}
function SMSTextBox({
  buttonStyle,
  text,
  selectedLead,
  handleKeyDown,
  handleKeyUp,
  canDisabledConversation,
  textDisabled,
  messageLoader,
  loading,
  spinner,
  leadsLoading,
  loaderFn,
  lang,
  setisReview,
  setinputText,
  placeholder,
  inputText,
  textMode,
  isTranslatePreviewShow,
  originalText,
  setOriginalText,
  translateMessage,
  setmessageText,
  richTextValue,
  setrichTextValue,
  user,
  setloaderFn,
  messageText,
}) {
  return (
    <>
      <div style={{ display: "flex", flexGrow: "1" }} className="relative -mx-2">
        <InputTextAreaWrap
          placeholderStyle={{
            color: buttonStyle()?.background === "#F59E0B" ? colorConfig.primaryDark : "",
          }}
          styling={buttonStyle()}
          className="relative resize-none focus-visible:outline-none border-none pr-[80px] pl-4 flex items-center rounded-[4px] pt-5 pb-5"
          id="text"
          ref={text}
          key={`msg_box_${selectedLead?.id}`}
          rows={1}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
          disabled={
            canDisabledConversation ||
            textDisabled() ||
            !selectedLead?.id ||
            messageLoader ||
            loading ||
            spinner ||
            leadsLoading ||
            loaderFn
          }
          onChange={e => {
            if (e.target.value === "") {
              text.current.placeholder = lang.typeYourMessageHere;
              text.current.value = "";
              text.current.style.height = "0px";
              setisReview(false);
            }
            e.target.style.height = `${e.target.scrollHeight}px`;
            setinputText(e.target.value);
          }}
          placeholder={placeholder()}
          // value={text.current?.value || inputText}
          // onChange={e => setmessageText(e.target.value)}
          name="text"
          maxLength={1000}
        />
      </div>
      {textMode !== 2 && (
        <div className="flex absolute right-3 bottom-3 items-center gap-1 justify-center">
          {isTranslatePreviewShow && (
            <Tooltip title={originalText ? "Back to original text" : "Translate text"}>
              <span
                onClick={() => {
                  if (!(text.current?.value.length > 0)) {
                    message.info("Please enter message to translate.");
                    return;
                  }
                  if (text.current?.value && !originalText) {
                    setOriginalText(text.current.value);
                    translateMessage({
                      variables: {
                        content: text.current?.value,
                        targetLanguage: selectedLead?.preferredLanguageCode,
                      },
                      onCompleted: res => {
                        if (res?.translateMessage?.statusCode === 200) {
                          setmessageText(res?.translateMessage?.translatedContent);
                          text.current.value = res?.translateMessage?.translatedContent;
                          message.info(res?.translateMessage?.message);
                        } else {
                          message.info(res?.translateMessage?.message);
                        }
                      },
                    });
                    return;
                  }
                  setmessageText(originalText);
                  text.current.value = originalText;
                  setOriginalText("");
                }}
              >
                <SVGIcon component={TranslateIcon} alt="Close" />
              </span>
            </Tooltip>
          )}
          <ChatMagic
            text={text}
            key={`otto_comp_${selectedLead?.id}`}
            richTextValue={richTextValue}
            setRichTextValue={setrichTextValue}
            selectedLead={selectedLead}
            user={user}
            placeholder={placeholder}
            setmessageText={setinputText}
            displaySize="small"
            loaderFn={loaderFn}
            setloaderFn={setloaderFn}
            code="ENGAGEMENT_MESSAGE_SUGGESTION"
            messageText={messageText}
            Component={({ createSuggestedResponse, misc }) => (
              <SuggestAMessageButton
                createSuggestedResponse={createSuggestedResponse}
                misc={misc}
                disabled={
                  textDisabled() ||
                  !selectedLead?.id ||
                  messageLoader ||
                  loading ||
                  spinner ||
                  leadsLoading
                }
                text={text}
                loaderFn={loaderFn}
                setloaderFn={setloaderFn}
                selectedLead={selectedLead}
                setinputText={setinputText}
              />
            )}
          />
        </div>
      )}
    </>
  );
}
